export const isEmptyContent = (html: string) => {
  const cleaned = html
    .replace(/<p[^>]*><br><\/p>/g, '') // <p><br></p> 패턴 제거
    .replace(/<h[1-6][^>]*><br><\/h[1-6]>/g, '') // <h1><br></h1>, <h2><br></h2>, ..., <h6><br></h6> 패턴 제거
    .trim();
  return cleaned === '';
};
